export default __webpack_public_path__ + "static/media/desk_preland_7.a4329159.jpg";